import React, { useState,useEffect } from 'react'
import {  Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser,faCartShopping,faClose } from '@fortawesome/free-solid-svg-icons'
import MenuLinks from './MenuLinks'

import { SearchBar } from './SearchBar'

function TopHeader({cartCount,user,navbar, setNavbar}) {
    


    const [headerFixed, setheaderFixed] = useState("relative w-full z-10");
    const [hideColumn,setHideColumn] = useState('md:block hidden');
    const listenScrollEvent = () => {
        window.scrollY > 100 ? setheaderFixed("fixed w-full top-0 z-10 mobileTopMinusTen") : setheaderFixed("relative w-full z-10");
        window.scrollY > 100 ? setHideColumn("md:block hidden") : setHideColumn("md:block hidden");
    };

    useEffect(() => {
          window.addEventListener("scroll", listenScrollEvent);
        return () => {
          window.removeEventListener("scroll", listenScrollEvent);
        };
      }, []);

  return (
    <>
    <section className='transition-all delay-150 top_header md:mx-0 px-3 py-4  bg-mybluecolor'>
        <div className='container mx-auto'>
            <div className='my_top_header flex md:flex-row flex-col gap-4 relative items-center'>

                <div className='md:basis-3/12 basis-full text-left'>
                    <Link to='/' end>
                        <img src={require('../Images/logo-shopwex.png')} alt="Logo" className='inline-block'/>
                    </Link>
                    <div className="md:hidden flex items-center absolute top-7 right-1">
                        {navbar ? 
                        <button className="outline-none mobile-menu-button"  onClick={() => setNavbar(!navbar)}>
                            <FontAwesomeIcon icon={faClose} className="text-2xl text-myorangeolor"/>
                        </button>
                        : 
                        <button className="outline-none mobile-menu-button"  onClick={() => setNavbar(!navbar)}>
                            <svg
                                className="w-6 h-6 text-myorangeolor"
                                x-show="!showMenu"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                viewBox="0 0 24 24" 
                                stroke="currentColor"
                            >
                                <path d="M4 6h16M4 12h16M4 18h16"></path>
                            </svg>
                        </button> 
                        }
                        
                    </div>

                     {/* Mobile Menu Starts Here */}
               
                     <div
                        className={`my_menus p-5 md:hidden mt-4 mb-0
                        relative bg-mybluecolor w-full
                        ${
                            navbar ? "block" : "hidden"
                        }`}
                    >
                        
                        
                        <MenuLinks user={user} set="flex-col" myMargin="mx-3"/>
                        
                    </div>
                    {/* Mobile Menu Ends Here */}


                </div>

                <div className='md:basis-5/12 basis-full'>

                    <SearchBar />

                </div>

                <div className={`md:block md:basis-4/12 basis-full`}>
                    <ul className='top_links_list flex flex-wrap md:gap-0 md:justify-evenly justify-center items-end sm:items-end gap-5'>
                        { !user? 
                            <>
                                <li className=''>
                                    <Link to='/login' className='text-xs sm:text-sm text-white font-primary font-medium duration-200 group-hover:text-myorangeolor inline'>
                                    <div className="text-sm m-auto mb-1 sm:mb-2 flex items-center justify-center text-center rounded-full text-white border-2 border-white w-[30px] h-[30px] sm:w-[40px] sm:h-[40px] leading-9 duration-200 group-hover:border-myorangeolor group-hover:text-myorangeolor">
                                        <FontAwesomeIcon className='w-[15px] h-[15px] sm:w-[20px] sm:h-[20px]' icon={faUser}/>
                                    </div>
                                    Login</Link>
                                </li>
                                <li className=''>
                                    <Link to='/signup' className='text-xs sm:text-sm text-white font-primary font-medium duration-200 group-hover:text-myorangeolor inline'>
                                    <div className="text-sm m-auto mb-1 sm:mb-2 flex items-center justify-center text-center rounded-full text-white border-2 border-white w-[30px] h-[30px] sm:w-[40px] sm:h-[40px] leading-9 duration-200 group-hover:border-myorangeolor group-hover:text-myorangeolor">
                                        <FontAwesomeIcon className='w-[15px] h-[15px] sm:w-[20px] sm:h-[20px]' icon={faUser}/>
                                    </div>
                                    Sign up</Link>
                                </li>
                            </>
                        : 
                            <li className=''>
                                <Link to='/my-orders' className='text-sm text-white font-primary font-medium duration-200 group-hover:text-myorangeolor inline'>
                                    <div className="text-sm m-auto mb-2 text-center rounded-full text-white border-2 border-white w-[40px] h-[40px] leading-9 duration-200 group-hover:border-myorangeolor group-hover:text-myorangeolor">
                                        <FontAwesomeIcon icon={faUser}/>
                                    </div>
                                    My Account</Link>
                            </li>
                        }

                        {/* <li className=''>
                            <Link to='/my-orders' className='text-sm text-white font-primary font-medium duration-200 group-hover:text-myorangeolor inline'>
                                <div className="text-sm m-auto mb-2 text-center rounded-full text-white border-2 border-white w-[40px] h-[40px] leading-9 duration-200 group-hover:border-myorangeolor group-hover:text-myorangeolor">
                                    <FontAwesomeIcon icon={faUser}/>
                                </div>
                                My Account</Link>
                        </li> */}
                        <li className='relative'>
                            <Link to='/cart' className='text-xs sm:text-sm text-white font-primary font-medium duration-200 group-hover:text-myorangeolor inline'>
                               
                                <div className="text-sm m-auto mb-1 sm:mb-2 flex items-center justify-center text-center rounded-full text-white border-2 border-white w-[30px] h-[30px] sm:w-[40px] sm:h-[40px] leading-9 duration-200 group-hover:border-myorangeolor group-hover:text-myorangeolor">
                                    <FontAwesomeIcon className='w-[15px] h-[15px] sm:w-[20px] sm:h-[20px]' icon={faCartShopping}/>
                                </div>
                                <span className='count_item absolute -top-[7px] right-[5px] w-[15px] h-[20px] cartCount text-white text-center text-sm rounded-full'>{cartCount}</span>
                            My Cart</Link>
                        </li>
                        <li className=''>
                            <a href='https://www.facebook.com/share/1DhBTxYsyF/?mibextid=wwXIfr' target='_blank' className='text-sm text-white font-primary font-medium duration-200 flex flex-col items-center'>
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" className='h-10 w-10 sm:w-12 sm:h-12' viewBox="0 0 48 48">
<path fill="#039be5" d="M24 5A19 19 0 1 0 24 43A19 19 0 1 0 24 5Z"></path><path fill="#fff" d="M26.572,29.036h4.917l0.772-4.995h-5.69v-2.73c0-2.075,0.678-3.915,2.619-3.915h3.119v-4.359c-0.548-0.074-1.707-0.236-3.897-0.236c-4.573,0-7.254,2.415-7.254,7.917v3.323h-4.701v4.995h4.701v13.729C22.089,42.905,23.032,43,24,43c0.875,0,1.729-0.08,2.572-0.194V29.036z"></path>
</svg>
<span className='mt-1 text-xs sm:text-sm'>Facebook</span>
</a>

</li>
<li className=''>
               <a href='https://www.instagram.com/wholesale.xpress?igsh=MXdrOHdodmpkaGEweg==' target='_blank' className='text-sm text-white font-primary font-medium duration-200 flex flex-col items-center'>
                            <svg xmlns="http://www.w3.org/2000/svg" className='h-8 w-8 sm:w-10 sm:h-10' viewBox="0 0 102 102" id="instagram">
  <defs>
    <radialGradient id="a" cx="6.601" cy="99.766" r="129.502" gradientUnits="userSpaceOnUse">
      <stop offset=".09" stop-color="#fa8f21"></stop>
      <stop offset=".78" stop-color="#d82d7e"></stop>
    </radialGradient>
    <radialGradient id="b" cx="70.652" cy="96.49" r="113.963" gradientUnits="userSpaceOnUse">
      <stop offset=".64" stop-color="#8c3aaa" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#8c3aaa"></stop>
    </radialGradient>
  </defs>
  <path fill="url(#a)" d="M25.865,101.639A34.341,34.341,0,0,1,14.312,99.5a19.329,19.329,0,0,1-7.154-4.653A19.181,19.181,0,0,1,2.5,87.694,34.341,34.341,0,0,1,.364,76.142C.061,69.584,0,67.617,0,51s.067-18.577.361-25.14A34.534,34.534,0,0,1,2.5,14.312,19.4,19.4,0,0,1,7.154,7.154,19.206,19.206,0,0,1,14.309,2.5,34.341,34.341,0,0,1,25.862.361C32.422.061,34.392,0,51,0s18.577.067,25.14.361A34.534,34.534,0,0,1,87.691,2.5a19.254,19.254,0,0,1,7.154,4.653A19.267,19.267,0,0,1,99.5,14.309a34.341,34.341,0,0,1,2.14,11.553c.3,6.563.361,8.528.361,25.14s-.061,18.577-.361,25.14A34.5,34.5,0,0,1,99.5,87.694,20.6,20.6,0,0,1,87.691,99.5a34.342,34.342,0,0,1-11.553,2.14c-6.557.3-8.528.361-25.14.361s-18.577-.058-25.134-.361"></path>
  <path fill="url(#b)" d="M25.865,101.639A34.341,34.341,0,0,1,14.312,99.5a19.329,19.329,0,0,1-7.154-4.653A19.181,19.181,0,0,1,2.5,87.694,34.341,34.341,0,0,1,.364,76.142C.061,69.584,0,67.617,0,51s.067-18.577.361-25.14A34.534,34.534,0,0,1,2.5,14.312,19.4,19.4,0,0,1,7.154,7.154,19.206,19.206,0,0,1,14.309,2.5,34.341,34.341,0,0,1,25.862.361C32.422.061,34.392,0,51,0s18.577.067,25.14.361A34.534,34.534,0,0,1,87.691,2.5a19.254,19.254,0,0,1,7.154,4.653A19.267,19.267,0,0,1,99.5,14.309a34.341,34.341,0,0,1,2.14,11.553c.3,6.563.361,8.528.361,25.14s-.061,18.577-.361,25.14A34.5,34.5,0,0,1,99.5,87.694,20.6,20.6,0,0,1,87.691,99.5a34.342,34.342,0,0,1-11.553,2.14c-6.557.3-8.528.361-25.14.361s-18.577-.058-25.134-.361"></path>
  <path fill="#fff" d="M461.114,477.413a12.631,12.631,0,1,1,12.629,12.632,12.631,12.631,0,0,1-12.629-12.632m-6.829,0a19.458,19.458,0,1,0,19.458-19.458,19.457,19.457,0,0,0-19.458,19.458m35.139-20.229a4.547,4.547,0,1,0,4.549-4.545h0a4.549,4.549,0,0,0-4.547,4.545m-30.99,51.074a20.943,20.943,0,0,1-7.037-1.3,12.547,12.547,0,0,1-7.193-7.19,20.923,20.923,0,0,1-1.3-7.037c-.184-3.994-.22-5.194-.22-15.313s.04-11.316.22-15.314a21.082,21.082,0,0,1,1.3-7.037,12.54,12.54,0,0,1,7.193-7.193,20.924,20.924,0,0,1,7.037-1.3c3.994-.184,5.194-.22,15.309-.22s11.316.039,15.314.221a21.082,21.082,0,0,1,7.037,1.3,12.541,12.541,0,0,1,7.193,7.193,20.926,20.926,0,0,1,1.3,7.037c.184,4,.22,5.194.22,15.314s-.037,11.316-.22,15.314a21.023,21.023,0,0,1-1.3,7.037,12.547,12.547,0,0,1-7.193,7.19,20.925,20.925,0,0,1-7.037,1.3c-3.994.184-5.194.22-15.314.22s-11.316-.037-15.309-.22m-.314-68.509a27.786,27.786,0,0,0-9.2,1.76,19.373,19.373,0,0,0-11.083,11.083,27.794,27.794,0,0,0-1.76,9.2c-.187,4.04-.229,5.332-.229,15.623s.043,11.582.229,15.623a27.793,27.793,0,0,0,1.76,9.2,19.374,19.374,0,0,0,11.083,11.083,27.813,27.813,0,0,0,9.2,1.76c4.042.184,5.332.229,15.623.229s11.582-.043,15.623-.229a27.8,27.8,0,0,0,9.2-1.76,19.374,19.374,0,0,0,11.083-11.083,27.716,27.716,0,0,0,1.76-9.2c.184-4.043.226-5.332.226-15.623s-.043-11.582-.226-15.623a27.786,27.786,0,0,0-1.76-9.2,19.379,19.379,0,0,0-11.08-11.083,27.748,27.748,0,0,0-9.2-1.76c-4.041-.185-5.332-.229-15.621-.229s-11.583.043-15.626.229" transform="translate(-422.637 -426.196)"></path>
</svg>
<span className='mt-2 text-xs sm:text-sm'>Instagram</span>
</a>
</li>
<li className='block sm:hidden'>
      <a href="https://www.viranihopefoundation.org/" target="_blank" className='text-white underline font-primary font-medium uppercase'>
      Virani Hope Foundation
    </a>
</li>

                    </ul>
                </div>

                   
                
                
            </div>
        </div>
    </section>
                
    </>
  )
}

export default TopHeader